import React, { useMemo, memo } from 'react';
import { Metric } from 'hooks/search';
import { Row } from 'antd';
import { useIntl } from 'react-intl';
import SocialLogo from 'components/SocialLogo';

import { useAuth } from 'hooks/auth';
import { Title, SocialCard, BlueDot, Cards } from './styles';

interface PostsByNetworkCardProps {
  data: Metric[];
  title?: string;
}

const PostsByNetworkCard: React.FC<PostsByNetworkCardProps> = ({
  data,
  title = '',
}) => {
  const intl = useIntl();
  const { isUserLogged } = useAuth();

  const formattedData: Array<{
    name: 'facebook' | 'instagram' | 'x' | 'misc';
    value: number;
  }> = useMemo(() => {
    let result = data
      ? data
          .map(
            service =>
              ({
                name: service.label === 'twitter' ? 'x' : service.label,
                value: service.value,
              } as {
                name: 'facebook' | 'instagram' | 'x' | 'misc';
                value: number;
              }),
          )
          .sort((a, b) => {
            return a.name.localeCompare(b.name);
          })
      : [];

    if (!isUserLogged) {
      result = result.filter(service => service.name !== 'x');
    }

    return result;
  }, [data, isUserLogged]);

  return (
    <Cards isUserLogged={isUserLogged}>
      {formattedData.map((service, index) => (
        <SocialCard key={index}>
          <Row style={{ display: 'flex', alignItems: 'center' }}>
            {service.name === 'x' ? (
              <SocialLogo
                social_network={service.name}
                style={{ marginRight: '8px' }}
              />
            ) : (
              <div
                style={{
                  marginRight: '8px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <SocialLogo
                  social_network={service.name}
                  style={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              </div>
            )}
            <Title>
              <a style={{ fontWeight: 'normal', fontSize: '14px' }}>
                {intl.formatMessage({ id: `results.service.${service.name}` })}
              </a>
            </Title>
          </Row>
          <Row
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              alignContent: 'center',
              minHeight: '34px',
              paddingLeft: '1px',
            }}
          >
            <Row style={{ alignItems: 'center', maxHeight: '250px', overflow: 'auto' }}>
              <BlueDot style={{ marginRight: '4px' }}></BlueDot>
              <a style={{ color: '#737373' }}>{title}</a>
            </Row>
            <a style={{ color: 'black', fontSize: 24 }}>{service.value}</a>
          </Row>
        </SocialCard>
      ))}
    </Cards>
  );
};

const comparisonFn = (
  prevProps: PostsByNetworkCardProps,
  newProps: PostsByNetworkCardProps,
): boolean => {
  return JSON.stringify(prevProps) === JSON.stringify(newProps);
};

export default memo(PostsByNetworkCard, comparisonFn);
